import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'
import * as types from '../store/types'

import Index from '@/components/index/Index'
import Product from '@/components/product/Product'
import Case from '@/components/case/Case'

Vue.use(VueRouter)

const routes = [{
	path: '/index',
	component: Index,
	children: [

	]
}, {
	path: '/',
	redirect: "/index"
}, {
	path: '/product', //产品介绍
	component: Product
}, {
	path: '/case', //案例
	component: Case
}];
const router = new VueRouter({
	//	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {
			x: 0,
			y: 0
		}
	}
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js